import { DRUM_BALL_COUNT } from '../../../core/constants/lottery';

// Layout data for the decorative balls tumbling inside the drum. Positions and
// drift are randomized once per mount so the machine never looks tiled; the
// values are handed to CSS custom properties and animated there.

const MIN_DURATION_S = 6;
const MAX_DURATION_S = 13;
const MIN_SIZE_PX = 20;
const MAX_SIZE_PX = 38;
const DRIFT_RANGE_PX = 54;
const SAFE_INSET_PCT = 16;

function between(min, max) {
    return min + Math.random() * (max - min);
}

export function buildDrumBalls(count = DRUM_BALL_COUNT) {
    return Array.from({ length: count }, (_, index) => ({
        id: index,
        digit: Math.floor(Math.random() * 10),
        size: Math.round(between(MIN_SIZE_PX, MAX_SIZE_PX)),
        left: between(SAFE_INSET_PCT, 100 - SAFE_INSET_PCT),
        top: between(SAFE_INSET_PCT, 100 - SAFE_INSET_PCT),
        driftX: Math.round(between(-DRIFT_RANGE_PX, DRIFT_RANGE_PX)),
        driftY: Math.round(between(-DRIFT_RANGE_PX, DRIFT_RANGE_PX)),
        duration: between(MIN_DURATION_S, MAX_DURATION_S).toFixed(2),
        delay: (-Math.random() * MAX_DURATION_S).toFixed(2),
    }));
}
